import { AbstractControl, ValidationErrors } from '@angular/forms';

export function passwordValidator(control: AbstractControl): ValidationErrors {
  return new RegExp('^.{8,}$').test(control.value) ? null : { password: true };
}
